export default "__VITE_PUBLIC_ASSET__73d2e7ca__"